import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Removes a dismissable banner on click. When a `url` value is present, it also
// POSTs to that url (CSRF-protected, keepalive) so the dismissal can be
// persisted server-side before the element is removed.
//
// Example usage:
// <div data-controller="dismissable-banner" data-dismissable-banner-url-value="/profile/welcome/dismiss">
//   <button data-action="dismissable-banner#dismiss">×</button>
// </div>
export default class extends Controller {
  static values = { url: String }

  dismiss() {
    if (this.urlValue) {
      // Fire-and-forget; keepalive lets it outlive the element removal below.
      // FetchRequest auto-handles CSRF.
      post(this.urlValue, { responseKind: "json", keepalive: true })
    }

    this.element.remove()
  }
}
